import script from "./shrink-wrap.vue?vue&type=script&setup=true&lang=ts"
export * from "./shrink-wrap.vue?vue&type=script&setup=true&lang=ts"

import "./shrink-wrap.vue?vue&type=style&index=0&id=1bcf19d2&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bcf19d2"]])

export default __exports__